import React, { Component } from 'react';
import {serverUrl} from '../../utils/restUtils'
import Share from '../Share'

class EventShow extends Component {
    componentDidMount(){
	this.props.showEvent(this.props.match.params.id)
    }

    componentWillUnmount(){
	this.props.clearEvent()
    }
    
    render() {
	const {event} = this.props
	return (
	    <div>
		{event ? 
		 <div>

		     <div className="news">
			 
			 <div className="">
			     {event.youtube_id==null ?
			      <img src={event.image_id ? serverUrl()+'/images/'+event.image_id : '/images/noimage.png'} className="full-width" alt={event.title} />
			     :
			      <div className="video">
				  <div>
				      <iframe src={`https://www.youtube.com/embed/${event.youtube_id}?autoplay=1`} frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
				  </div>
			      </div>
			     }
			     <div className={['title', event.category].join(' ')}>
				 <h5>{event.subtitle}</h5>
				 <h4>{event.title}</h4>
			     </div>
				  </div>

				  <div>
				      <h3> {(!event.category ? event.title : event.location)} <br /> {(!event.category ? event.subtitle : event.event_on)}</h3>
				      <div className="description" dangerouslySetInnerHTML={{__html: event.description.replace(new RegExp("src=\"api/", 'g'), "src=\""+serverUrl()+'/')}}></div>
				  </div>
				  <hr style={{borderTop: '1px solid black'}} />
				  <Share title={event.title} />
			      </div>	  
			 </div>
		:
		 null }
		     </div>
	);
	
    }
}
export default EventShow;



// WEBPACK FOOTER //
// ./src/components/EventShow/index.jsx